<template>
	<div class="message-box dialog-mask">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title">{{ $t(title, i18nData) }}</h4>
				</div>
				<div class="modal-body">
					<p v-html="$t(content, i18nData)"></p>
				</div>
				<div class="modal-footer">
					<ModalMultiButtons
						:loading="loading"
						:btnPrimaryText="$t(confirmLabel)"
						:btnSecondaryText="$t(cancelLabel)"
						:primaryButtonClick="clickYes"
						:secondaryButtonClick="clickNo"
						:secondaryButtonHide="!cancelLabel"
					></ModalMultiButtons>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { ModalMultiButtons } from '@arena/toolkit';

export default {
	components: {
		ModalMultiButtons,
	},
	props: {
		title: String,
		content: String,
		confirmLabel: {
			type: String,
			default: 'Ok',
		},
		confirmResult: {
			default: true,
		},
		confirmFunction: {
			type: Function,
			default: null,
		},
		cancelLabel: {
			type: String,
			default: '',
		},
		cancelResult: {
			default: false,
		},
		i18nData: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			loading: false,
		};
	},
	methods: {
		async clickYes() {
			try {
				if (this.confirmFunction) {
					this.loading = true;
					this.confirmResult = await this.confirmFunction();
				}
				this.$close(this.confirmResult);
			} catch (error) {
				this.$error(error);
			}
		},
		clickNo() {
			this.$close(this.cancelResult);
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/common/dialogs/confirm.vue